import { render, staticRenderFns } from "./lawyerCertificate.vue?vue&type=template&id=61cdbf74"
import script from "./lawyerCertificate.vue?vue&type=script&lang=js"
export * from "./lawyerCertificate.vue?vue&type=script&lang=js"
import style0 from "./lawyerCertificate.vue?vue&type=style&index=0&id=61cdbf74&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports